module.exports = __webpack_public_path__ + "img/gemini.3697aba6.png";